module.exports = __webpack_public_path__ + "img/soam.0cfcecf0.png";